module.exports = __webpack_public_path__ + "img/pr_4.ce5c69dd.png";